import React, { useState, useEffect, useMemo, useContext } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchManager from "../components/template/SearchManager";
import SearchManagerComponent from "../components/SearchManager/SearchManagerComponent";
import BannerCard from "../components/BannerCard";
import TemplateForms from "../components/TemplateForms";
import no_data from "../images/No_Template_Found_Icon.svg";
import "../css/TemplateManger.scss";
import "react-toastify/dist/ReactToastify.css";
import CreateTemplate from "../components/CreateTemplate";
import { template, eDetail } from "../utils/constants";
import CircularProgressBar from "../utils/CircularProgressBar";
import toggleInactive from "../images/toggle-inactive.svg";
import toggleActive from "../images/toggle-active.svg";
import ScrollableChipComp from "../components/SearchManager/ScrollableChipComp";
import GileadModal from "../components/GileadModal";
import WebActionVeeva from "../components/WebActionPage/WebActionVeeva";
import { getMarketDetails, getBrandDetails, getMlrStatusList, getIndicationDetails } from "../services/apis";
import CloneEdetailModal from "../components/modals/CloneEdetailModal";
import ValueContext from "../utils/contextAPI/contextAPI";
// import AdvanceFilterModal from "../components/AdvanceFilterModal/AdvanceFilterModal";


const EDetailForm = ({
  openCreateNewPresenationModal,
  createNewEdetail,
  openCreateNewtemplate,
  setOpenCreateNewtemplate,
  // isloading,
  type,
  // setIsloading,
  createEdetail,
  createTemplate,
  createPresentationFields,
  setCreatePresentationFields,
  edetailList,
  setEDetailFields,
  eDetailFields,
  sendSearchDataToEdetails,
  // searchClick,
  // setSearchClick,
  searchClickEdetail,
  setSearchClickEdetail,
  // searchClicktemplate,
  // setSearchClicktemplate,
  deleteEdetailCard,
  createFromTemplate,
  isOpenCreateFromTemp,
  setIsOpenCreateFromTemp,
  setEdetailList,
  setShowHeading,
  showHeading,
  //showResults,
  lastSearch,
  searchresults,
  textFieldValidationError,
  onProceedHandler,
  campaign,
  market,
  brands,
  totalCount,
  handleExportModal,
  clicKRsdPreview,
  closeExportModal,
  openExportModal,
  handleExport,
  marketDataList,
  fetchMore,
  showFetchedResults,
  setshowFetchedResults,
  setCreatedbyMe,
  hasMore,
  skipRange,
  createdbyMe,
  showCount,
  setHasMore,
  setShowCount,
  setCreatedbyOthers,
  setLastSearch,
  infinteScrollRef,
  createdByOthers,
  cardDetailsHandler,
  cardDetails,
  expired,
  setExpired,
  expireTemplateHandler,
  sharedToggle,
  setSharedToggle,
  // openShardedHandler,
  isOpenSharedModal,
  onToggleProceedHandler,
  deckIdCurrent,
  localShared,
  setLocalShared,
  setIsOpenSharedModal,
  setDeckIdCurrent,
  cameFrom,
  fetchingList,
  fetchingListError,
}) => {
  /*  const [showFetchedResults, setshowFetchedResults] = useState([]);
   const [skipRange, setSkipRange] = useState(101);
   const [hasMore, setHasMore] = useState(true);
   const [createdbyMe, setCreatedbyMe] = useState(true);
   const [showCount, setShowCount] = useState(totalCount) */
  const appData = useContext(ValueContext);  
  const [sourceEdetailData, setSourceEdetailData] = useState(null);
  const [isloading, setIsloading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [countriesList, setCountriesList] = useState([]);
  const [brandsList, setBrandsList] = useState();
  const [mlrStatusList, setMLRStatusList] = useState([]);
  const [openAdvanceFilterModal, setOpenAdvanceFilterModal] = useState(false);
  const [brandSelected, setBrandSelected] = useState([]);
  const [marketSelected, setMarketSelected] = useState([]);
  const [mlrSelected, setMlrSelected] = useState([]);
  // const [selectedItems, setSelectedItems] = useState({});
  const [indicationList, setIndicationList] = useState([]);
// console.log(selectedItems, 'brandSelected--', brandSelected)
  const fetchMarket = () => {
      getMarketDetails((response, err, errCode) => {
        if (err) {
        } else {
          //parse and save
          // const data = response.data;
          if (response) {
            setCountriesList(response.data);
          }
        }
      });
  };

  const fetchBrands = () => {
     getBrandDetails((response, err, errCode) => {
        if (err) {
        } else {
          //parse and save
          // const data = response.data;
          if (response) {
            setBrandsList(response.data);
          }
        }
      });
  }

  const fetchMLRStatus = () => {
     getMlrStatusList((response, err, errCode) => {
        if (err) {
        } else {
          if (response) {
            setMLRStatusList(response.data);
          }
        }
      });
  }

  const fetchIndication = () => {
     getIndicationDetails((response, err, errCode) => {
        if (err) {
        } else {
          //parse and save
          // const data = response.data;
          if (response) {
            setIndicationList(response.data);
          }
        }
      });
  }
  
  useEffect(() => {
    fetchMarket();
    fetchBrands();
    fetchMLRStatus();
    fetchIndication()
  },[])

  const openCloneEdetailModal = (edetailId) => {
    let res = showFetchedResults?.find(
      (element) => element.type === eDetail && element._id === edetailId
    );
    if (res?.device) {
      let id =
        typeof res.device === "string" ? res.device : res?.device?._id;
      let name = appData.devices.filter((item) => item?._id === id)[0].name;
      res.device = { name: name, _id: id };
    }
    setSourceEdetailData(res);
  };
  
  const closeCloneEdetailModal = () => {
    setSourceEdetailData(null);
  };


  const renderSearchResultsBlock = useMemo(() => {
    return (
      <div className="searchResultBlock customScrollBar">
        {countriesList && showFetchedResults?.length > 0 ? (
          <InfiniteScroll
            dataLength={showFetchedResults.length}
            next={() => fetchMore(createdbyMe, skipRange, true, expired)}
            hasMore={hasMore}
            scrollableTarget="scrollableDiv"
            ref={infinteScrollRef}
          >
            <div className={`dashboard-card-parent-div ${searchClickEdetail ? 'filtersAppliedHeight':'withoutFilterAppliedHeight'}`} id="scrollableDiv">
            <div className="dashboard-card-child-div">
              {showFetchedResults.map((item, index) => {
                const imageKey = Date.now(); //Math.floor(Math.random() * 10);
                return (
                  <div className="col-md-2 bannerCard" key={index}>
                    <BannerCard
                      cardData={item}
                      openCloneEdetailModal={openCloneEdetailModal}
                      deleteEdetailCard={deleteEdetailCard}
                      type={item.type}
                      showFetchedResults={showFetchedResults}
                      setshowFetchedResults={setshowFetchedResults}
                      clicKRsdPreview={clicKRsdPreview}
                      handleExportModal={handleExportModal}
                      closeExportModal={closeExportModal}
                      openExportModal={openExportModal}
                      handleExport={handleExport}
                      createdbyMe={createdbyMe}
                      cardDetailsHandler={cardDetailsHandler}
                      cardDetails={cardDetails}
                      imageKey={imageKey}
                      expireTemplateHandler={expireTemplateHandler}
                      brands={brandsList}
                      countriesList={countriesList}
                    />
                  </div>
                );
              })}
              </div>
              </div>
          </InfiniteScroll>
        ) : (<>
            {fetchingList ? 
            <div className="result-not-found">
              <div className="d-flex justify-content-center align-items-center" style={{position: "absolute", top: "0"}}>
              <div className="result-not-found-text">                
                <h2 className="result-not-found-messages">Loading...</h2>
                <h3 className="result-not-found-parameters"></h3>
                </div>
              </div>
            </div>
            :
          <div className="result-not-found">
            <div className="d-flex justify-content-center align-items-center" style={{position: "absolute", top: "0"}}>
            <img
              className="result-not-found-icon"
              src={no_data}
              width={600}
              height={321}
              alt=""
            />
              <div className="result-not-found-text">                
              <h2 className="result-not-found-messages">{fetchingListError?"Unable to load right now. Please try again.":(searchClickEdetail?'NO e-Detail FOUND':'Create your First e-Detail')}</h2>
              <h3 className="result-not-found-parameters">{fetchingListError?'':(searchClickEdetail?'Please try searching with other search parameters':'')}</h3>
              </div>
            </div>
          </div>}
          </>
        )}
      </div>
    );
  }, [showFetchedResults, createdbyMe, countriesList, brandsList, fetchingList, fetchingListError]);
  const showHeadingres = searchClickEdetail
    ? `Search Results (${searchresults || 0})`
    : `E-details (${showCount || 0})`;

  const limit = 100;

  const switchToCreatedBy = (flag) => {
    infinteScrollRef?.current?.el?.scrollTo(0, 0);
    setCreatedbyMe(flag)
    fetchMore(flag, 0, false, expired);
    setHasMore(true);
    // setSearchClickEdetail(false);
    /* if (flag === "Me") {
      fetchMore(true, 0, false, expired);
      setCreatedbyOthers(false);
      setHasMore(true);
    } else {
      fetchMore(false, 0, false, expired);
      setCreatedbyOthers(true);
      setHasMore(true);
    } */
  };

  const createFromTemplateMetaData = (metadata) => {
    setCreatePresentationFields({ ...metadata });
  };

  const handleChange = (event) => {
    infinteScrollRef?.current?.el?.scrollTo(0, 0);
    //setExpired(event.target.checked);
    setExpired(!expired);
    fetchMore(createdbyMe, 0, false, !expired);
  };
  useEffect(() => {
   // if(cameFrom=='/webaction')
   // setShowModal(true)
  },[])
// console.log(marketSelected, 'marketSelected', brandSelected)
  return (
    <>
      {" "}
      {isloading && (
        <CircularProgressBar
          isloading={isloading}
          setIsloading={setIsloading}
        />
      )}
      <div className=""> {/* templatePageContainer */}
        {/* <div className="createNewEdetailbtnBlock">
          <div className="eDetail-Label">e-Detail Manager</div>
          <div className="createEdetailbtnBlock">
            <button
              type="button"
              className="btn btn-primary"
              onClick={openCreateNewPresenationModal}
            >
              CREATE NEW e-DETAIL
            </button>
          </div>
        </div> */}
        {/* <SearchManager
          marketDataList={marketDataList}
          setEDetailFields={setEDetailFields}
          eDetailFields={eDetailFields}
          sendSearchDataToEdetails={sendSearchDataToEdetails}
          searchClickEdetail={searchClickEdetail}
          setSearchClickEdetail={setSearchClickEdetail}
          // searchClicktemplate={searchClicktemplate}
          // setSearchClicktemplate={setSearchClicktemplate}
          type={type}
          setEdetailList={setEdetailList}
          // showResults={showResults}
          showHeading={showHeading}
          setShowHeading={setShowHeading}
          brands={brands}
          market={market}
          campaign={campaign}
          createdbyMe={createdbyMe}
          setCreatedbyMe={setCreatedbyMe}
          lastSearch={lastSearch}
          setLastSearch={setLastSearch}
          infinteScrollRef={infinteScrollRef}
          setCreatedbyOthers={setCreatedbyOthers}
          expired={expired}
          setExpired={setExpired}
        /> */}
        <div className="search-manager-container-board" >
          <SearchManagerComponent  
            marketDataList={marketDataList}
            brands={brands}  
            market={countriesList}
            showCount={showCount}
            createPresentationFields={createPresentationFields}
            setCreatePresentationFields={setCreatePresentationFields}
            type={type}
            switchToCreatedBy={switchToCreatedBy}
            sendSearchDataToEdetails={sendSearchDataToEdetails}
            createdbyMe={createdbyMe}
            openCreateNewPresenationModal={openCreateNewPresenationModal}
            searchClickEdetail={searchClickEdetail}
            countriesList={countriesList} 
            setCountriesList={setCountriesList}
            brandsList={brandsList}
            setBrandsList={setBrandsList}
            mlrStatusList={mlrStatusList}
            setMLRStatusList={setMLRStatusList}
            indicationList={indicationList}
            >
            
          </SearchManagerComponent>
          </div>
        <div > {/* className="row mt-3 g-0 tabSeparation" */}
         
          {/* <div className="col-md-6 g-0 searchResult">
            <div
              className={`createdByMe createdBy ${createdbyMe && !createdByOthers ? "createdByActive" : ""
                }`}
              onClick={() => switchToCreatedBy("Me")}
            >{`Created by Me ${createdbyMe && !createdByOthers && showCount !== " "
                ? `(${showCount < 10 && showCount > 0
                  ? `0${showCount}`
                  : showCount
                })` || 0
                : ""
              }`}</div>
            <div
              className={`createdByOthers createdBy ${!createdbyMe && createdByOthers ? "createdByActive" : ""
                }`}
              onClick={() => switchToCreatedBy("Others")}
            >{`Created by Others ${!createdbyMe && createdByOthers
                ? `(${showCount < 10 && showCount > 0
                  ? `0${showCount}`
                  : showCount
                })` || 0
                : ""
              }`}</div>
          </div>
          <div
            className={`col-md-6 g-0 expireToggleSection toggleExpiredForEdetail`}
          >
            {" "}
            Show Expired e-Detail{" "}
            
            <img
              src={expired ? toggleActive : toggleInactive}
              className="expireToggleActive"
              onClick={handleChange}
            />{" "}
            
          </div> */}
        </div>

        {renderSearchResultsBlock}
      </div>
      {openCreateNewtemplate ? (
         <GileadModal
          openCreateNewtemplate={openCreateNewtemplate}
          setOpenCreateNewtemplate={setOpenCreateNewtemplate}
          type={type}
        ></GileadModal> 
/*         <TemplateForms
          marketDataList={marketDataList}
          textFieldValidationError={textFieldValidationError}
          createPresentationFields={createPresentationFields}
          setCreatePresentationFields={setCreatePresentationFields}
          createNewEdetail={createNewEdetail}
          openCreateNewtemplate={openCreateNewtemplate}
          setOpenCreateNewtemplate={setOpenCreateNewtemplate}
          isloading={isloading}
          setIsloading={setIsloading}
          type={eDetail}
          createEdetail={createEdetail}
          createTemplate={createTemplate}
          createFromTemplate={createFromTemplate}
          createFromTemplateMetaData={createFromTemplateMetaData}
          campaign={campaign}
          market={market}
          brands={brands}
          sharedToggle={sharedToggle}
          setSharedToggle={setSharedToggle}
          // openShardedHandler={openShardedHandler}
          deckIdCurrent={deckIdCurrent}
          setLocalShared={setLocalShared}
          localShared={localShared}
        />  */
      ) : (
        isOpenCreateFromTemp && (
          <CreateTemplate
            createPresentationFields={createPresentationFields}
            type={template}
            // createPresentationFields={createPresentationFields}
            setCreatePresentationFields={setCreatePresentationFields}
            isOpenCreateFromTemp={isOpenCreateFromTemp}
            setIsOpenCreateFromTemp={setIsOpenCreateFromTemp}
            onProceedHandler={onProceedHandler}
            createdbyMe={createdbyMe}
            brands={brands}
            sharedToggle={sharedToggle}
            setSharedToggle={setSharedToggle}
            // openShardedHandler={openShardedHandler}
            onToggleProceedHandler={onToggleProceedHandler}
            deckIdCurrent={deckIdCurrent}
            localShared={localShared}
          />
        )
      )}

      {cameFrom == "webaction" ?<WebActionVeeva
        showModal={showModal}
        setShowModal={setShowModal}
        setLocalShared={setLocalShared}
        localShared={localShared}
        marketLi={market}
        brands={brands}
        marketDataList={marketDataList}
        type={eDetail}
      /> : ''}

      
            {sourceEdetailData && (
              <CloneEdetailModal
                sourceEdetailData={sourceEdetailData}
                closeCloneEdetailModal={closeCloneEdetailModal}
                brands={brands}
                marketDataListFetch={marketDataList}
                setIsOpenSharedModal={setIsOpenSharedModal}
                setDeckIdCurrent={setDeckIdCurrent}
                //  
              />
            )}
    </>
  );
};

export default EDetailForm;
